import { AuthFlowType, B2BProducts } from '@stytch/vanilla-js'

export const SESSION_DURATION_MINUTES = 1440 // 24 hours

export const discoveryConfig = {
  products: [B2BProducts.passwords],
  sessionOptions: { sessionDurationMinutes: SESSION_DURATION_MINUTES },
  authFlowType: AuthFlowType.Discovery,
  directLoginForSingleMembership: {
    status: true,
    ignoreInvites: true,
    ignoreJitProvisioning: true
  }
}

export const stytchOptions = {
  endpointOptions: {
    testApiDomain: 'stytch-staging.instaleap.io',
    apiDomain: 'stytch.instaleap.io'
  }
}

export const discoveryStyles = {
  container: {
    backgroundColor: '#FFFFFF',
    borderColor: '#1b474f',
    borderRadius: '8px',
    width: '400px'
  },
  colors: {
    primary: '#1b474f',
    secondary: '#5C727D',
    success: '#0C5A56',
    error: '#8B1214'
  },
  buttons: {
    primary: {
      backgroundColor: '#29ce6c',
      textColor: '#FFFFFF',
      borderColor: '#29ce6c',
      borderRadius: '4px'
    },
    secondary: {
      backgroundColor: '#ffffff',
      textColor: '#1b474f',
      borderColor: '#1b474f',
      borderRadius: '4px'
    }
  },
  inputs: {
    backgroundColor: '#FFFFFF00',
    borderColor: '#1b474f',
    borderRadius: '4px',
    placeholderColor: '#8296A1',
    textColor: '#1b474f'
  },
  fontFamily: 'Roboto',
  hideHeaderText: false,
  logo: {
    logoImageUrl: 'https://instaleap.io/wp-content/uploads/2022/10/Instaleap-Logo-1.png'
  }
}
